import { IbssPage } from '../../../../Components/Core/BasePage/IbssPage';
import { Card, Grid, Typography } from '@mui/material';
import IbssButton from '../../../../Components/Buttons/Button/IbssButton';
import { appContext } from '../../../../AppContext';
import IbssTimePicker from '../../../../Components/Inputs/TimePicker/IbssTimePicker';
import { getWkngDaysBySelectedBuilding } from '../../../../Common/Helper';
import { IUserPreferences } from '../../../../Providers.Api/UserPreferences/UserPreferenceRepository';
import { DateHelper } from '../../../../Common/DateHelper';
import { PageHelper } from './PageHelper';
import { DateTime } from 'luxon';

class WorkingDayState
{
    public startTime: DateTime | null = null;
    public endTime: DateTime | null = null;
    public isLoading = false;
    public BuildingSpecificNotification = PageHelper.getUserPrefrenceJson();
    public startTimeError = "";
    public endTimeError = "";
}

class WorkingDay extends IbssPage<IProps, WorkingDayState> {
    private labels = appContext().labels;
    private alert = appContext().alert;
    private userPreferences = appContext().userPreferencesService;
    private local = appContext().localStorageProvider;

    constructor(props: IProps)
    {
        super(props)
        this.state = new WorkingDayState();
    };

    componentDidMount()
    {
        this.pageTitle = this.labels.HubMenuWorkplacePreferences;
        this.setState({ isLoading: true });
        const response = this.local.getUserPreferences();
        this.setState({ isLoading: false, BuildingSpecificNotification: response });


        const getStrtDate: any = getWkngDaysBySelectedBuilding(response?.SearchPrefs?.DefaultBuilding);
        let Occ_Wkng_Hrs_Stt = getStrtDate?.Occ_Wkng_Hrs_Stt.split(":");
        let Hrs_Stt = Occ_Wkng_Hrs_Stt[0] + ":" + Occ_Wkng_Hrs_Stt[1];
        let Occ_Wkng_Hrs_Stp = getStrtDate?.Occ_Wkng_Hrs_Stp.split(":");
        let Hrs_Stp = Occ_Wkng_Hrs_Stp[0] + ":" + Occ_Wkng_Hrs_Stp[1];

        // set start time
        let startTime = ""
        if (response?.WorkingHoursPrefs?.UserStartTime != "date" && response?.WorkingHoursPrefs?.UserStartTime != "" && response?.WorkingHoursPrefs?.UserStartTime != null && response?.WorkingHoursPrefs?.UserStartTime != undefined)
        {
            startTime = response.WorkingHoursPrefs.UserStartTime;
        }
        else if (response?.WorkingHoursPrefs?.UserStartTime == "" || response?.WorkingHoursPrefs?.UserStartTime == null || response?.WorkingHoursPrefs?.UserStartTime == undefined)
        {
            startTime = Hrs_Stt;
        }
        const myStartTime = DateTime.fromFormat(startTime, "HH:mm");
        // set end time
        let endTime = "";
        if (response?.WorkingHoursPrefs?.UserEndTime != "date" && response?.WorkingHoursPrefs?.UserEndTime != "" && response?.WorkingHoursPrefs?.UserStartTime != null && response?.WorkingHoursPrefs?.UserStartTime != undefined)
        {
            endTime = response.WorkingHoursPrefs.UserEndTime;
        }
        else if (response?.WorkingHoursPrefs?.UserEndTime == "" || response?.WorkingHoursPrefs?.UserEndTime == null || response?.WorkingHoursPrefs?.UserEndTime == undefined)
        {
            endTime = Hrs_Stp;
        }
        const myEndTime = DateTime.fromFormat(endTime, "HH:mm");
        this.setState({
            startTime: myStartTime,
            endTime: myEndTime,
        });

    };
 
    private handleStartTimeChange(time: DateTime | null): void
    {
        if (!time) return;
        const endTime = this.state.endTime;
        const startTimeError = endTime && time > endTime ? this.labels.HubLabelMustBeBeforeTheEndTime : "";
        const endTimeError = endTime && endTime < time ? this.labels.HubLabelMustBeAfterTheStartTime : "";
        this.setState({
            startTime: time,
            startTimeError,
            endTimeError
        });
    };
 
    private handleEndTimeChange(time: DateTime | null): void
    {
        if (!time) return;
        const startTime = this.state.startTime;
        const endTimeError = startTime && time < startTime ? this.labels.HubLabelMustBeAfterTheStartTime : "";
        const startTimeError = startTime && startTime > time ? this.labels.HubLabelMustBeBeforeTheEndTime : "";
        this.setState({
            endTime: time,
            endTimeError,
            startTimeError
        });
    };

    public submit = async () =>
    {
        if (!this.state.startTime?.isValid || !this.state.endTime?.isValid || this.state.startTimeError.length > 0 || this.state.endTimeError.length > 0)
        {
            return;
        }
 
        this.setState({ isLoading: true });
 
        const startTime = this.state.startTime.toFormat("HH:mm");
        const endTime = this.state.endTime.toFormat("HH:mm");
 
        const payload: IUserPreferences =
        {
            ...this.state.BuildingSpecificNotification,
            WorkingHoursPrefs:
            {
                UserStartTime: startTime,
                UserEndTime: endTime,
            },
        };

        try
        {
            await this.userPreferences.update(payload);
            this.alert.show(this.labels.HubLabelSuccess, this.labels.HubLabelDataHasBeenSavedSuccessfully);
        }
        catch { }
        this.setState({ isLoading: false })
    };


    render()
    {
        return (
            <>
                <Grid container>
                    <Card className='card-userPref'>
                        <Grid
                            container
                            gap={1}
                        >
                            <Typography className='card-userPref-title' variant="h6" gutterBottom>{this.labels.HubTitleWorkingDay}</Typography>

                            <Typography className='card-userPref-text mb-32' variant="body2" marginBottom={"32px"}>{this.labels.HubSubTitleWorkingDay}</Typography>

                        </Grid>
                        <div className='space-between al-c'>
                            <div id='start-time' className="date-label">{this.labels.HubLabelStartTime}</div>
                            <div>
                                <IbssTimePicker
                                    className='ibss-timepicker'
                                    value={this.state.startTime}
                                    onChange={(e)=>this.handleStartTimeChange(e)}
                                    ampm
                                    minutesStep={15}
                                    slotProps={{
                                        textField: {
                                            inputProps: {
                                                'aria-labelledby': 'start-time',
                                            },
                                            error: this.state.startTimeError.length > 0,
                                            helperText: this.state.startTimeError
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        <div className='space-between al-c'>
                            <div id='end-time' className="date-label">{this.labels.HubLabelEndTime}</div>
                            <div>
                                <IbssTimePicker
                                    className='ibss-timepicker'
                                    value={this.state.endTime}
                                    onChange={(e)=>this.handleEndTimeChange(e)}
                                    ampm
                                    minutesStep={15}
                                    minTime={this.state.startTime ?? undefined}
                                    slotProps={{
                                        textField: {
                                            inputProps: {
                                                'aria-labelledby': 'end-time',
                                            },
                                            error: this.state.endTimeError.length > 0,
                                            helperText: this.state.endTimeError
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    </Card>
                </Grid>
                <div className='btn-right'>
                    <IbssButton variant='contained' onClick={() => this.submit()} disabled={!this.state.startTime?.isValid || !this.state.endTime?.isValid || this.state.startTimeError.length > 0 || this.state.endTimeError.length > 0}>
                        {this.labels.HubButtonSave}
                    </IbssButton>
                </div>
            </>
        )
    }
};

export default WorkingDay;

export interface IProps
{
}